var React                         = require("react");
var classnames                    = require("classnames");
var LinesEllipsis                 = require("react-lines-ellipsis/lib");
var HTMLEllipsis                  = require("react-lines-ellipsis/lib/html");
var ChallengeCard                 = require("./challenge_card");
var CardRatioContainer            = require("./card_ratio_container");

var primaryColor = window._infl.branding.themeColorPrimary;
var { withNamespaces } = require('react-i18next');

var ChannelFooter = withNamespaces('HubFE')(function({ channel, rewriteLook, t }) {
  var { total_challenge_count, unseen_challenge_count } = channel;
  return(
    <footer className="channel-card__footer">
      <span className="channel-card__footer-content">
        {rewriteLook
          ? total_challenge_count === 1 ? `${total_challenge_count} challenge` : `${total_challenge_count} challenges`
          : t('{{count}} Challenge', { count: total_challenge_count || 0 })}
      </span>
      {unseen_challenge_count > 0 &&
        <p className="channel-card__footer-content-wrapper">
          <span className="channel-card__footer-content">•</span>
          <strong>{t('{{count}} New', { count: unseen_challenge_count > 9 ? '9+' : unseen_challenge_count })}</strong>
        </p>}
    </footer>
  );
});

const Ellipsis = ({ text }) =>
  <LinesEllipsis text={text} maxLine={3} ellipsis={'...'} basedOn='letters'/>;

const HtmlEllipsis = ({ text }) =>
  <HTMLEllipsis unsafeHTML={text} maxLine={3} ellipsisHTML={'...'} basedOn='letters'/>;

var Overlay = function({ darkMode, primaryColorOverlay, isPreview, rewriteLook }) {
  return primaryColorOverlay && isPreview ?
    <div className="channel-card__tint-overlay channel-card__primary-color-overlay" style={{backgroundColor: primaryColor}} /> :
    <div className={classnames({
      "channel-card__tint-overlay": true,
      "channel-card__tint-overlay__rewrite": rewriteLook,
      "channel-card__dark-overlay": darkMode && !primaryColorOverlay,
      "channel-card__light-overlay": !darkMode && !primaryColorOverlay,
      "channel-card__primary-color-overlay": primaryColorOverlay,
    })} />
};

var Gradient = function({ darkMode, primaryColorOverlay, isPreview, rewriteLook }) {
  return primaryColorOverlay && isPreview ?
  <div className={classnames({
      "channel-card__gradient": true,
      "channel-card__gradient__rewrite": rewriteLook
    })}
    style={{background: `linear-gradient(transparent 0%, ${primaryColor})`}} /> :
  <div className={classnames({
    "channel-card__gradient": true,
    "channel-card__gradient__rewrite": rewriteLook,
    "channel-card__gradient_dark": darkMode && !primaryColorOverlay,
    "channel-card__gradient_dark__rewrite": darkMode && !primaryColorOverlay && rewriteLook,
    "channel-card__gradient-light": !darkMode && !primaryColorOverlay,
    "channel-card__gradient-light__rewrite": !darkMode && !primaryColorOverlay && rewriteLook,
    "channel-card__primary-color-inner": primaryColorOverlay,
    "channel-card__primary-color-inner__rewrite": primaryColorOverlay && rewriteLook
  })} />
};

var ChannelCard = React.createClass({
  PropTypes: {
    channel: React.PropTypes.object,
    channelPath : React.PropTypes.object.isRequired,
    hideCounters: React.PropTypes.bool,
    homepageUrl: React.PropTypes.string.isRequired,
    isPreview: React.PropTypes.bool,
    shortCardDesignEnabled: React.PropTypes.bool,
    rewriteLook: React.PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      channel: {},
      channelPath: {},
      isPreview: false
    }
  },

  render: function() {
    var { channel, isPreview, rewriteLook } = this.props;
    var notVisible = !channel.total_challenge_count && !this._channelWithoutChallengeVisibility() && !isPreview;
    
    if (notVisible) return null;
    const darkMode = this.props.channel.dark_mode_on;
    const primaryColorOverlay = this.props.channel.primary_color_overlay;
    return (
      <div className={classnames({"channel-card": true, "channel-card__rewrite": rewriteLook})} key={channel.id}>
        <ChallengeCard id={`channel-${channel.id}`}>
          <a href={!isPreview ? this._getChannelUrl() : '#'} className="card__link" aria-label={channel.name}>
            <CardRatioContainer
              shortCardDesignEnabled={this.props.shortCardDesignEnabled}
              rewriteLook={rewriteLook}>
              <div className={classnames({
                "card__wrapper": true,
                "card__wrapper__rewrite": rewriteLook
              })}>
                <div className={classnames({
                  "channel-card__image-container": true,
                  "channel-card__image-container__rewrite": rewriteLook
                })}>
                  <div style={this._getBackgroundStyle()} />
                </div>
                <div className="card__content card__text-wrapper">
                  <div className={classnames({
                    "channel-card__inner-content-container": true,
                    "channel-card__inner-content-container__rewrite": rewriteLook
                  })}>
                    <Overlay darkMode={darkMode} primaryColorOverlay={primaryColorOverlay} isPreview={isPreview} rewriteLooks={rewriteLook} />
                    <Gradient darkMode={darkMode} primaryColorOverlay={primaryColorOverlay} isPreview={isPreview} rewriteLook={rewriteLook} />
                    <div className={classnames({
                        "channel-card__tint-overlay-inner": true,
                        "channel-card__light-inner": !darkMode
                      })}>
                      <h3 className={classnames({
                        "channel-card__headline": true,
                        "channel-card__headline__rewrite": rewriteLook
                      })}>
                        <Ellipsis text={channel.name}/>
                      </h3>
                      <div className="channel-card__description">
                        <HtmlEllipsis text={channel.description}/>
                      </div>
                      <div className={classnames({
                        "channel-card__horizontal-line": darkMode,
                        "channel-card__horizontal-line__rewrite": rewriteLook,
                        "channel-card__horizontal-line-light": !darkMode,
                        "channel-card__horizontal-line-light__rewrite": rewriteLook
                      })}/>
                      <ChannelFooter channel={channel} rewriteLook={rewriteLook} />
                    </div>
                  </div>
                </div>
              </div>
            </CardRatioContainer>
          </a>
        </ChallengeCard>
      </div>
    );
  },

  _getBackgroundStyle: function() {
    const { channel } = this.props;
    const bgStyle = {
      width: '100%',
      height: '100%',
      backgroundColor: this.props.rewriteLook ? `${primaryColor}14` : primaryColor
    };

    if (channel.image_url) {
      bgStyle.backgroundImage = `url(${channel.image_url})`;
      bgStyle.backgroundSize = 'cover';
      bgStyle.backgroundRepeat = 'no-repeat';
      bgStyle.backgroundPosition = '50% 50%';
    }

    return bgStyle;
  },

  _getChannelUrl: function() {
    return this.props.channelPath({id: this.props.channel.id});
  },

  _channelWithoutChallengeVisibility: function() {
    return window && window._infl &&
    window._infl.hub && window._infl.hub.features &&
    window._infl.hub.features.includes('channel_without_challenge_visibility') || false;
  }
});

module.exports = ChannelCard;



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/channel_card.jsx